export default {
  steppers: state => state.steppers
};
